import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";

export default function ModalPreview(props) {
  const { isOpen, handleModalClose, nameUserEditting } = props;
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (isOpen) {
      setCountdown(5);
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate("/list-article");
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isOpen, navigate]);

  return (
    <Modal
      style={{ height: "400px",marginTop:"10%" }}
      open={isOpen}
      okText={"Đóng"}
      onOk={()=>{    navigate("/list-article");}}
      zIndex={1000}
      onCancel={handleModalClose}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ width: "100%", marginTop: "30px" }}>
        <p
          style={{
            textAlign: "center",
            fontSize: "18px",
            marginTop: "10px",
          }}
        >
          Bài viết này đang được chỉnh sửa bởi <b>{nameUserEditting}</b>.
        </p>
        <p
          style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold" }}
        >
          {countdown}
        </p>
      </div>
    </Modal>
  );
}
